@if (pdfJob.toast$ | async; as toast) {
  @if (toast.status !== 'hidden') {
    <div class="pdf-job-toast" role="status" aria-live="polite">
      <button
        type="button"
        class="pdf-job-toast__close"
        (click)="pdfJob.dismissToast()"
        aria-label="Dismiss">
        <mat-icon>close</mat-icon>
      </button>

      @if (toast.status === 'preparing') {
        <div class="pdf-job-toast__row">
          <mat-spinner diameter="22"></mat-spinner>
          <div>
            <div class="pdf-job-toast__title">Preparing report</div>
            <div class="pdf-job-toast__message">{{ toast.message }}</div>
          </div>
        </div>
      }

      @if (toast.status === 'success') {
        <div class="pdf-job-toast__title">Report ready</div>
        <div class="pdf-job-toast__message">{{ toast.message }}</div>
        <div class="pdf-job-toast__hint">Not downloaded yet?</div>
        <button
          type="button"
          class="pdf-job-toast__action"
          (click)="pdfJob.downloadAgain()">
          Download Again
        </button>
      }

      @if (toast.status === 'failed') {
        <div class="pdf-job-toast__title">Report generation failed</div>
        <div class="pdf-job-toast__message">{{ toast.message }}</div>
        <button
          type="button"
          class="pdf-job-toast__action"
          (click)="pdfJob.tryAgain()">
          Try again
        </button>
      }
    </div>
  }
}
